import React from 'react';
import { Section } from './ui/Section';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheck, Coffee } from 'lucide-react';
export function PricingSection() {
  return <Section background="rose" id="pricing" data-id="element-93">
      <div className="max-w-3xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden border border-rose-100" data-id="element-94">
        <div className="bg-rose-500 p-4 text-center" data-id="element-95">
          <p className="text-white font-bold tracking-wide uppercase text-sm" data-id="element-96">
            Oferta por tiempo limitado
          </p>
        </div>

        <div className="p-8 md:p-12 text-center" data-id="element-97">
          <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-98">
            Obtén acceso inmediato hoy
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-99">
            El ebook completo + los 3 bonos de regalo
          </p>

          <div className="mb-10" data-id="element-100">
            <div className="flex justify-center mb-6" data-id="element-101">
              <div className="relative" data-id="element-102">
                <img src="https://cdn.magicpatterns.com/uploads/6mHR95aYqiKteTwzfHgtr4/ChatGPT_Image_31_ene_2026,_03_36_32_p.m..png" alt="Portada del ebook Di Esto, No Aquello™" className="w-44 md:w-52 rounded-xl shadow-lg" data-id="element-103" />
              </div>
            </div>
            <p className="text-sm font-semibold text-gray-700 mb-6" data-id="element-104">
              Di Esto, No Aquello™ — Ebook Principal
            </p>

            <div className="flex items-center gap-3 mb-6 max-w-xs mx-auto" data-id="element-105">
              <div className="flex-1 h-px bg-gray-200" data-id="element-106"></div>
              <span className="text-xs font-bold text-rose-400 uppercase tracking-wider" data-id="element-107">
                + 3 Bonos
              </span>
              <div className="flex-1 h-px bg-gray-200" data-id="element-108"></div>
            </div>

            <div className="flex justify-center items-end gap-4 md:gap-6" data-id="element-109">
              <div className="flex flex-col items-center" data-id="element-110">
                <img src="https://cdn.magicpatterns.com/uploads/nBHycezXfKtJw92fLEEpgw/portada_bono_1.png" alt="Bono 1: Guía de Mensajes de Texto para Reducir Conflictos" className="w-24 md:w-28 rounded-lg shadow-md -rotate-2" data-id="element-111" />
                <span className="text-xs text-gray-500 mt-2 max-w-[100px] leading-tight" data-id="element-112">
                  Bono 1
                </span>
              </div>
              <div className="flex flex-col items-center" data-id="element-113">
                <img src="https://cdn.magicpatterns.com/uploads/mfQsrshLShwGu2bTks1AtS/portada_bono_2.png" alt="Bono 2: Qué Decir Cuando Él Se Cierra" className="w-24 md:w-28 rounded-lg shadow-md" data-id="element-114" />
                <span className="text-xs text-gray-500 mt-2 max-w-[100px] leading-tight" data-id="element-115">
                  Bono 2
                </span>
              </div>
              <div className="flex flex-col items-center" data-id="element-116">
                <img src="https://cdn.magicpatterns.com/uploads/9Q4hcFw7ooaQM5KC9hdSP2/portada_bono_3.png" alt="Bono 3: Scripts de Emergencia" className="w-24 md:w-28 rounded-lg shadow-md rotate-2" data-id="element-117" />
                <span className="text-xs text-gray-500 mt-2 max-w-[100px] leading-tight" data-id="element-118">
                  Bono 3
                </span>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-2 mb-8" data-id="element-119">
            <span className="text-5xl font-extrabold text-gray-900" data-id="element-120">$9.99</span>
            <span className="text-xl text-gray-400 line-through font-medium" data-id="element-121">
              $47
            </span>
          </div>

          <div className="flex items-center justify-center gap-2 text-sm text-gray-500 mb-8 bg-gray-50 py-2 px-4 rounded-full inline-flex mx-auto" data-id="element-122">
            <Coffee className="h-4 w-4" data-id="element-123" />
            <span data-id="element-124">Menos de lo que cuestan dos cafés</span>
          </div>

          <CTAButton fullWidth className="text-xl py-5 mb-6" onClick={() => window.open('https://pay.hotmart.com/H104303411I', '_blank')} data-id="element-125">
            Descargar Ebook + Bonos Ahora
          </CTAButton>

          <div className="flex items-center justify-center gap-2 text-gray-500 text-sm" data-id="element-126">
            <ShieldCheck className="h-5 w-5 text-green-500" data-id="element-127" />
            <span data-id="element-128">
              Garantía de satisfacción de 14 días. Si no te sirve, te devolvemos
              tu dinero.
            </span>
          </div>
        </div>
      </div>
    </Section>;
}